import React from "react";
import { useState,useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/SalesReportBySortflag.css';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import Loading from './Loading';
import { format } from "date-fns";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
//import SalespersonSidebar from "./SalespersonSidebar";



const columns = [   
    {
        field: 'order_id',
        headerName: 'Order ID',
        cellClassName:'order_id_column',headerClassName:'order_id_header',  
        flex:1, 
        // minWidth: 80, 
        sortable:false,
    },
     {
        field: 'first_name',
        headerName: 'First Name',
        cellClassName:'first_name_column',headerClassName:'first_name_header',  
        flex:1, 
        // minWidth: 110, 
        sortable:false,
    },
     {
        field: 'last_name',
        headerName: 'Last Name',
        cellClassName:'last_name_column',headerClassName:'last_name_header',  
        flex:1, 
        // minWidth: 90, 
        sortable:false,
    },
        {
        field: 'email',
        headerName: 'Email',
        flex:1,
        sortable: false,
        // minWidth:222,
        cellClassName:'email_column',headerClassName:'email_header', 
         renderCell: (params) => (
        <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.email}
          </Link>
      ),
        
      },
      {
        field: 'country',
        headerName: 'Country',
        cellClassName:'country_column',headerClassName:'country_header',  
        flex:1, 
        // minWidth: 88, 
        sortable:false,
    },
    {
        field: 'salesperson',
        headerName: 'Salesperson',
        cellClassName:'salesperson_column',headerClassName:'salesperson_header',  
        flex:1, 
        // minWidth: 120, 
        sortable:false,
    },
    {
        field: 'products_purchased',
        headerName: 'Product Purchased',
        cellClassName:'product_purchased_column',headerClassName:'product_purchased_header',  
        flex:1, 
        // minWidth: 160, 
        sortable:false,
    },
    
    {
        field: 'ship_amount',
        headerName: 'Shipping',
        cellClassName:'shipping_amount_column',headerClassName:'shipping_amount_header',  
        flex:1, 
        // minWidth: 69, 
        sortable:false,
    },
    {
        field: 'amount',
        headerName: 'Amount Paid',
        cellClassName:'amount_paid_column',headerClassName:'amount_paid_header',  
        flex:1, 
        // minWidth: 68, 
        sortable:false,
    },
  
    {
        field: 'payment_date',
        headerName: 'Payment Date',
        cellClassName:'payment_date_column',headerClassName:'payment_date_header',  
        flex:1, 
        // minWidth: 82, 
        sortable:false,
    },
    {
        field: 'payment_method',
        headerName: 'Payment Method',
        cellClassName:'payment_method_column',headerClassName:'payment_method_header',  
        flex:1, 
        // minWidth: 110, 
        sortable:false,
    },
   
  
];




const SalesReportBySortflag = () => { 
      const initialForm = () => {
       const params = new URLSearchParams(window.location.search);
       const defaultForm = {    
        sortflags:[],        
        start_date:'',
        start_date_obj: null,
        end_date:'',
        end_date_obj: null,
        sales_type:'all_sale',
        payment_method:'All' ,
        action:''       
    };

    const sortflags = (() => {
        const values = [];

        for (const [key, value] of params.entries()) {
            if (key.startsWith("sortflags[")) {
            if (value) values.push(value);
            }
        }

        return values;
        })();

     const queryStart = params.get("start_date");
    const queryEnd = params.get("end_date");

    // const startObj =
    //   queryStart && !isNaN(new Date(queryStart))
    //     ? new Date(queryStart + "T00:00:00")
    //     : null;

    // const endObj =
    //   queryEnd && !isNaN(new Date(queryEnd))
    //     ? new Date(queryEnd + "T00:00:00")
    //     : null;
    const startObj =
  queryStart
    ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
    : null;

const endObj =
  queryEnd
    ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
    : null;
         return {
    ...defaultForm,
    start_date: startObj ? queryStart : '',
    start_date_obj: startObj,

    end_date: endObj ? queryEnd : '',
    end_date_obj: endObj,

     sortflags: sortflags,
    //  Other fields
    sales_type: params.get("sales_type") || defaultForm.sales_type,
    payment_method: params.get("payment_method") || defaultForm.payment_method,
    
    action: ''
  };
};

    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState(initialForm());
    const [appliedFormData, setAppliedFormData] = useState(initialForm());
    const [formErrors, setFormErrors] =useState({});
    const[sortflagList, setSortflagList] = useState({});
    const [submittedData, setSubmittedData] = useState(null);  
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const[totalAmount, setTotalAmount] = useState(0);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const app_url = configData.APP_URL;

    
    const handleSortFlagFocusChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, sortflags: selectedValues }));
    };
    
//   const handleDateChange = (name, date) => {
//     const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
//     setFormData((prev) => ({
//       ...prev,
//       [name]: formattedDate
//     }));
//   };
    const handleDateChange = (date, field) => {
    setFormData(prev => ({
        ...prev,
        [`${field}_obj`]: date,                   
        [field]: date ? format(date, 'yyyy-MM-dd') : '' 
    }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    useEffect(() => { 
        retrieveSortFlags();        
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000); 

        return () => clearTimeout(timer); 
     
    },[]); 
    async function  retrieveSortFlags() {
    
        try {
            setIsLoading(true);
            const response = await fetch(
                app_url+'sortflag/getsortflaglist',
                {
                    method: "GET",
    
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setSortflagList(responsedata.data.result);
            }
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    }

     React.useEffect(() => {
          if(formData.start_date && formData.end_date) {
              const fetchData = async () => {
              // Simulate API call to your server
               // In a real application, replace this with your actual fetch logic
         try {
          setIsLoading(true);
        const response = await fetch(app_url+'sortflag/sortflagsalesreport', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sortModel,
            filterModel,
            //formData:formData
            formData: {
                ...appliedFormData,
                action: isSubmitted ? 'submit' : ''
            }
          }),
        });
        const data = await response.json();
        console.log(data.data.rows);
        setRows(data.data.rows);
        setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        setTotalAmount(data.data.totalpayment);
        }  catch (error) {
              console.error('Error fetching data:', error);
            } finally {
              setIsLoading(false); // Set loading to false after fetch completes (success or error)
                 if (isSubmitted) {
                  setIsSubmitted(false);
                }
            }
            
      };
      
  
      fetchData();
    }
        }, [paginationModel, sortModel, filterModel, appliedFormData]); // Re-fetch data when these change 
        const validateDates = (formData) => {
  let errors = {};

  if (!formData.start_date) {
    errors.start_date = "Start date is required.";
  }

  if (!formData.end_date) {
    errors.end_date = "End date is required.";
  }

  if (formData.start_date && formData.end_date) {
    if (formData.end_date < formData.start_date) {
      errors.end_date = "Start date can't over end date.";
    }
  }

  return errors;
};
  const submitFormData = async (data) => {
  setSubmittedData(data);
  setAppliedFormData(data);
  setIsSubmitted(false);
};
      const handleSubmit = async (e) => {
          e.preventDefault(); // stop page reload
              const errors = validateDates(formData);

  if (Object.keys(errors).length > 0) {
    console.log("Validation errors:", errors);
    setFormErrors(errors); 
    return;
  }
   setFormErrors({});
          setSubmittedData(formData);
          setAppliedFormData({...formData});
          setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
     setIsSubmitted(true);
    //    try {
    //       setIsLoading(true);
    //     const response = await fetch(app_url+'sortflag/sortflagsalesreport', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify({
    //         page: 0,
    //         pageSize: 50,
    //         sortModel,
    //         filterModel,
    //         formData:formData
    //       }),
    //     });
    //     const data = await response.json();
      
    //     setRows(data.data.rows);
    //     setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    //      setTotalAmount(data.data.totalpayment);
        
    //     }  catch (error) {
    //           console.error('Error fetching data:', error);
    //         } finally {
    //           setIsLoading(false); // Set loading to false after fetch completes (success or error)
    //         }
     
      
      };
  
      const handleExport = async (e) => {
          e.preventDefault(); // stop page reload
              const errors = validateDates(formData);

  if (Object.keys(errors).length > 0) {
    console.log("Validation errors:", errors);
    setFormErrors(errors); 
    return;
  }
   setFormErrors({});
     
          try {
              setIsLoading(true);
              const response = await fetch(app_url+'sortflag/sortflagsalesreportexport', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                      formData:formData
                  }),
              });
              const data = await response.json();
             const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
        
          }  catch (error) {
              console.error('Error fetching data:', error);
          } finally {
              setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
      };


// useEffect(() => {
//   const params = new URLSearchParams(window.location.search);

//   if ([...params.keys()].length > 0) {
//     const init = initialForm();

//     setFormData(init);

//     submitFormData(init);              
//   }
// }, []);  
const normalizeBackendData = (backendParams) => {
  return {
    ...backendParams,

    start_date_obj: backendParams.start_date
      ? new Date(backendParams.start_date.replace(/-/g, "/") + " 00:00:00")
      : null,

    end_date_obj: backendParams.end_date
      ? new Date(backendParams.end_date.replace(/-/g, "/") + " 00:00:00")
      : null,
  };
};

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const reportViewId = params.get("report_view_id");

  const baseForm = initialForm(); 

  if (reportViewId) {
    const fetchData = async () => {
      try {
        const res = await fetch(app_url + 'report/getreportfilters', {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: reportViewId }),
        });

        const data = await res.json();
        const backendParams = data?.data?.params || {};

        //  normalize backend
        const normalized = normalizeBackendData(backendParams);

        //  merge (backend overrides URL/defaults)
        const finalData = {
          ...baseForm,
          ...normalized,
        };

        setFormData(finalData);
        submitFormData(finalData);

      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  } else {
    //  fallback → only URL/default
    if ([...params.keys()].length > 0) {
      setFormData(baseForm);
      submitFormData(baseForm);
    }
  }

}, []);
  

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main" className="sales-reports-bysortflag-main">
                    <Helmet><title>Sort Flags Sales Report</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="sales-report-bysortflag-container">
                            <h1>Sort Flags Sales Report</h1>
                       <div className="messages warning">                            
                            &nbsp;&nbsp;If you're looking up large amounts of data, please wait for the report to load.<br/><br/>
                            &nbsp;&nbsp;If your search is not successful (i.e. system crashes), try a shorter date range.                            
                        </div>
                        <div className="messages_details">
                        Salespeople who are not in the divvy draft will show as Lynn Lashbrook. The exported data file will show the accurate salesperson.
                        </div>
                            <form onSubmit={handleSubmit}>
                                <fieldset style={{border:0}}>                                  
                                  
                                    <div className="sales-report-bysortflag-flex">
                                        <div>
                                            <select 
                                        name="sortflags" 
                                        multiple={true}
                                        size="15" 
                                        style={{width:"40%"}}
                                        className="sales-report-bysortflag-form-select" 
                                        onChange={handleSortFlagFocusChange}
                                        value={formData.sortflags || []}
                                    >
                                        {sortflagList.length > 0 && (
                                            <>
                                                {sortflagList.map((item) => {
                                                    return <>
                                                        {item['id'] != null && (
                                                            <><option value={item['id']}>{item['name']}</option></>
                                                        )}
                                                    </>
                                                })}  
                                            </>
                                        )}
                                    </select>
                                        </div>
                                        
                                        <div>
                                         <label htmlFor="start_date">Start Date:</label>
                                           
                                            <DatePicker
                                                ref={startDateRef}
                                                // selected={
                                                // formData.start_date
                                                //     ? new Date(formData.start_date)
                                                //     : null
                                                // }
                                                selected={formData.start_date_obj}
                                                onChange={(date) => {
                                                    handleDateChange(date, "start_date");
                                                    setTimeout(() => {
                                                        const input = startDateRef.current?.input;
                                                        if (input) {
                                                        const len = input.value.length;
                                                        input.setSelectionRange(len, len);
                                                        }
                                                    }, 0);
                                                }}
                                                name="start_date"
                                                id="pay_start_date"
                                                // required
                                            /> 
                                             
                                                {formErrors.start_date && (
                                                <div className="error">{formErrors.start_date}</div>
                                                )} 
                                            <br /><br />
                                            <label htmlFor="end_date">End Date:</label>
                                          
                                            <DatePicker
                                                // selected={
                                                // formData.end_date
                                                //     ? new Date(formData.end_date)
                                                //     : null
                                                // }
                                                ref={endDateRef}
                                                selected={formData.end_date_obj}
                                                onChange={(date) => {
                                                    handleDateChange(date, "end_date");
                                                    setTimeout(() => {
                                                        const input = endDateRef.current?.input;
                                                        if (input) {
                                                        const len = input.value.length;
                                                        input.setSelectionRange(len, len);
                                                        }
                                                    }, 0);
                                                }}
                                                name="end_date"
                                                id="pay_end_date"
                                                // required
                                            />
                                              {formErrors.end_date && (
                                            <div className="error">{formErrors.end_date}</div>
                                            )}
                                            <br /><br />
                                        <div>
                                            <label>Sales Type:</label>
                                            <select name="sales_type" style={{height: "25px",width:"156px"}}
                                               value={formData.sales_type} 
                                               onChange={handleChange}> 
                                                <option value="all_sale">All sales</option>
                                                <option value="first_sale">First-time sales</option>
                                                </select>
                                        </div>
                                        <div>
                                           <label htmlFor="pay">Payment Method</label>
                                     <select id="pay" name="payment_method" className="sales-report-byproduct-formselect" 
                                   value= {formData.payment_method} 
                                   onChange={handleChange}
                                     >
                                <option value="All">All</option>
                                <option value="sezzle">Sezzle</option>
                                <option value="authnet_aim">Credit Card</option>
                                <option value="paypal_wps">Paypal</option>
                                    </select><br /><br />
                                           
                                                
                                        </div>
                                        <div>
                                            <input type="submit" name="" value="submit" className="form-submit" />&nbsp; 
                                            <input type="button" name="" value="export" className="form-submit" onClick={handleExport} />&nbsp;
                                            
                                        </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                             {submittedData && (
                                <>
                            <div className="totals-container">
                            
                                <div id="total_apps"style={{padding: "25px", marginRight:"20px"}}>Total Amount: {totalAmount}</div>
                          
                            </div>
        

                            <div className="sales-report-bysortflag-popupdata">
                                <div className="sales-report-bysortflag-content">
                                    <table className="sales-report-bysortflag-table">
                                        <div>
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={() => crypto.randomUUID()}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                              //  disableColumnResize={true}
                                            />
                                        </div>
                                    </table>
                                </div>
                            </div>
                      </>
)}
                        </div>
                    </div>
                    
                </div>
            )}
        </>
    );
};
export default SalesReportBySortflag;